import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '@/i18n/LanguageContext';
import { Button } from '@/components/ui/button';
import { Container, TricolourRibbon } from '@/components/common/Layout';

export default function NotFoundPage() {
  const { t } = useLang();
  return (
    <div>
      <section className="hero-surface">
        <Container className="py-24 text-center">
          <div className="text-6xl font-display font-bold text-[#062B5C]">404</div>
          <h1 className="mt-4 font-display text-2xl font-semibold text-[#0B1220]">Page not found</h1>
          <p className="mt-3 text-[#5B6B82] max-w-md mx-auto">The page you&apos;re looking for doesn&apos;t exist. Head back to explore NGRP.</p>
          <div className="mt-6">
            <Link to="/">
              <Button className="bg-[#062B5C] text-white hover:bg-[#05244d]">{t('common.back_home')}</Button>
            </Link>
          </div>
        </Container>
      </section>
      <TricolourRibbon />
    </div>
  );
}
